export const cities = [
  'Ljubljana',
  'Maribor',
  'Kranj',
  'Koper',
  'Celje',
  'Novo mesto',
  'Velenje',
  'Ptuj',
  'Trbovlje',
  'Kamnik',
  'Jesenice',
  'Nova Gorica',
  'Domžale',
  'Škofja Loka',
  'Murska Sobota',
  'Izola',
  'Sežana',
  'Slovenska Bistrica',
  'Grosuplje',
  'Litija',
  'Rogaška Slatina',
  'Slovenske Konjice',
  'Lendava',
  'Črnomelj',
  'Hrastnik',
  'Radovljica',
  'Žalec',
  'Idrija',
  'Ilirska Bistrica',
  'Postojna',
  'Brežice',
  'Logatec',
  'Metlika',
  'Piran',
  'Cerknica',
  'Ruše',
  'Mežica',
  'Prevalje',
  'Šentjur',
  'Žiri',
  'Bled',
  'Sevnica',
  'Gornji Grad',
  'Osilnica',
  'Jezersko',
  'Bovec',
  'Luče',
  'Osilnica',
  'Vrhnika',
  'Letališče Jožeta Pučnika Ljubljana',
  'Letališče Edvarda Rusjana Maribor',
  'Kanin',
  'Iskrba',
  'Trzin',
  'Krvavec',
  'Ljubljana - Vič',
  'Letališče Portorož',
  'Letališče Lesce',
  'Radenci',
  'Mengeš',
  'Velike Lašče',
];
